import GLightbox from 'glightbox';

(function(window, document) {
    'use strict';

    if(document.querySelector('.glightbox') !== null) {
        GLightbox({
            selector: '.glightbox',
            // Gilt nur für Inline-Slides (z. B. SVGs), Bilder behalten ihre natürliche Größe.
            width: 'min(90vw, 1400px)',
            height: 'auto',
        });
    }

})(window, document);
